import { useEffect } from "react"
import { useParams } from "react-router-dom"

import useFetch from "shared/model/useFetch"
import useAlertModalAtom from "shared/model/useAlertModalAtom"

const usePostFreerollRegister = (setIsAgreeModalOpen) => {
    const { idx } = useParams()

    const [fetchResult, fetchRequest] = useFetch()
    const [, setAlert] = useAlertModalAtom()

    const clickEvent = () => {
        fetchRequest("POST", `/event/${idx}/freeroll/register`)
    }

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 200:
                setAlert("프리롤 대회 참가권 발급이 완료되었습니다.")
                setIsAgreeModalOpen(false)
                break
            case 400:
                if (fetchResult?.data?.error_code === "event_idx") setAlert("대회 idx 입력 양식을 확인해 주세요.")
                else setAlert("입력한 값의 형식이 잘못되었습니다.")
                break
            case 403:
                if (fetchResult?.data?.error_code === 1) setAlert("종료된 대회 입니다.")
                else if (fetchResult?.data?.error_code === 2) setAlert("아직 접수 중이지 않은 대회 입니다.")
                else if (fetchResult?.data?.error_code === 3) setAlert("요구되는 프로 자격을 만족하지 않습니다.")
                else if (fetchResult?.data?.error_code === 4) setAlert("엔트리가 마감되었습니다.")
                else if (fetchResult?.data?.error_code === 5) setAlert("이미 발급 받은 참가권이 있습니다.")
                else if (fetchResult?.data?.error_code === 6) setAlert("리엔트리 횟수를 초과하였습니다.")
                else if (fetchResult?.data?.error_code === 7) setAlert("프리미엄 계정이 아닙니다.")
                else if (fetchResult?.data?.error_code === 8) setAlert("참가권이 모두 소진되었습니다.")
                else if (fetchResult?.data?.error_code === 9) setAlert("레지가 마감되었습니다.")
                break
            case 404:
                if (fetchResult?.data?.error_code === 1) setAlert("대회 데이터가 존재하지 않습니다.")
                else if (fetchResult?.data?.error_code === 2) setAlert("매니저 데이터가 존재하지 않습니다.")
                break

        }
    }, [fetchResult])

    return [clickEvent]
}

export default usePostFreerollRegister